import { ButtonType } from '@fluentui/react';
import { forwardRef, Ref } from 'react';

import { singleOrArrayToArray } from '../../utils/utils';
import { Button, IButtonProps } from '../Button/Button';
import { buttonStylesIconInlineBlock, buttonStylesInlineRight } from '../Button/Button.styles';

export interface IClipboardButtonProps extends IButtonProps {
  content: string | undefined;
  filename: string;
  block?: boolean;
}

// Adapted from https://stackoverflow.com/a/18197341/5819564
function downloadFile(filename: string, text: string) {
  const element = document.createElement('a');
  element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
  element.setAttribute('download', filename);
  element.setAttribute('data-testid', 'download-button');

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export const DownloadButton = forwardRef(
  ({ content, filename, styles, block = false, ...rest }: IClipboardButtonProps, ref: Ref<HTMLDivElement>) => {
    const baseStyles = block ? buttonStylesIconInlineBlock : buttonStylesInlineRight,
      allStyles = [baseStyles, ...singleOrArrayToArray(styles)];

    return (
      <Button
        ref={ref}
        styles={allStyles}
        buttonType={ButtonType.icon}
        title={`Click to download "${filename}"`}
        iconName="Download"
        onClick={() => downloadFile(filename, content || '')}
        {...rest}
      />
    );
  }
);
